import React from 'react';
import { useSiteContext } from '../../context/SiteContext';
import SafeIcon from '../../common/SafeIcon';

const SeoSection = () => {
  const { data } = useSiteContext();
  const locations = data.seoLocations?.filter(l => l.active).sort((a, b) => a.sortOrder - b.sortOrder) || [];

  if (locations.length === 0) return null;

  return (
    <section id="locations" className="py-20 bg-[#13131a] border-t border-white/5">
      <div className="w-full max-w-[1440px] 2xl:max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-8 2xl:px-10">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">Where does BPA Solutions build website systems across Australia?</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            BPA Solutions builds website systems for Australian businesses, with local service information and enquiry pathways designed around each business's needs.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {locations.map((loc, idx) => (
            <div key={idx} className="p-6 rounded-2xl bg-white/5 border border-white/5">
              <div className="flex items-center gap-2 mb-3">
                <SafeIcon name="Map" className="w-5 h-5 text-blue-400" />
                <h3 className="text-lg font-bold text-white">{loc.region}, {loc.state}</h3>
              </div>
              <p className="text-sm text-slate-400 mb-6">{loc.introCopy}</p>
              <div className="bg-black/20 rounded-xl p-4">
                <p className="font-medium text-slate-200 mb-2 text-sm flex items-start gap-2">
                  <strong className="text-blue-400 shrink-0">Q:</strong> {loc.aeoQuestion}
                </p>
                <p className="text-slate-400 text-sm flex items-start gap-2">
                  <strong className="text-purple-400 shrink-0">A:</strong> {loc.aeoAnswer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SeoSection;